export default __webpack_public_path__ + "static/media/lager_822_hero_1.f8cc89fc.jpg";